
import { Component, Vue, Watch } from "vue-property-decorator";
import { AuthModule } from "@/store/auth";

@Component({
  components: {
  },
})
export default class App extends Vue {
  private componentKey = 0;
  private showLogoutError = false;

  private get currentToken() {
    return AuthModule.currentEventToken;
  }

  private get currentEventInfo() {
    return AuthModule.currentEventInfo;
  }

  @Watch("currentEventInfo", { immediate: true })
  onChildChanged(val: any): void {
    const currentDate = AuthModule.currentTime;

    if (!val || Object.keys(val).length === 0) {
      return;
    }
    if (currentDate > new Date(val.enddate).getTime()) {
      this.showLogoutError = true;
      this.handleLogout(val);
    }
  }

  public async created(): Promise<void> {
    if (this.currentToken) await AuthModule.GetEventInfo();
  }

  public mounted(): void {
    setInterval(async () => {
      if (this.currentToken === null) {
        return;
      } else {
        await AuthModule.GetEventInfo();
      }
    }, 3600 * 24);
  }

  public async handleLogout(expiredEventObj?: any): Promise<void> {
    await AuthModule.LogoutUser();
    if (expiredEventObj) {
      sessionStorage.setItem("expiredEvent", JSON.stringify(expiredEventObj));
    }
    if (this.showLogoutError) {
      this.$router.push("/Expired").catch((err) => console.log(err));
    } else {
      this.$router.push("/").catch((err) => console.log(err));
    }
    this.showLogoutError = false;
    this.componentKey++;
  }
}
